import type { FC } from "react";

import { StoreLocatorCount } from "@locators/components/shared/components/StoreLocatorCount";
import { ViewSwitch } from "@locators/components/shared/components/ViewSwitch";
import type { MobileViewOnChange } from "@locators/components/shared/hooks/useMobileView";

import styles from "./StoreLocatorMobileInfoContainer.module.scss";

type StoreLocatorMobileInfoContainerProps = Partial<MobileViewOnChange>;

export const StoreLocatorMobileInfoContainer: FC<StoreLocatorMobileInfoContainerProps> = ({ onChangeResultType }) => {
  return (
    <div className={styles.mobileInfoContainer}>
      <StoreLocatorCount />
      <ViewSwitch onChangeResultType={onChangeResultType ?? (() => undefined)} className={styles.viewSwitchContainer} />
    </div>
  );
};
